// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".c95035a78bd7f6711328d31d5e1a3d6450bb7989.chunk.bundle.js";
};